import type { TDataExportValueTypesTimeseriesGroup } from 'App/data-export/types/from-code-gen/TDataExportValueTypesTimeseriesGroup'
import { translate } from 'i18n/i18n'
import { degreeDaysRecord, trapCatchesRecord } from 'stores/selectedValueGroupsStore/insectValueGroupRecords'
import { getInsectNameFromId } from 'utils/getInsectNameFromId'

const insectDegreeDaysLabelMaker = (insectId: number) => () =>
  translate.phrases.banyanApp('{{insectName}} Degree Days', { insectName: getInsectNameFromId(insectId) })

const insectTrapCatchesLabelMaker = (insectId: number) => () =>
  translate.phrases.banyanApp('{{insectName}} Trap Catches', { insectName: getInsectNameFromId(insectId) })

export const mapValueGroupToLabel: Record<TDataExportValueTypesTimeseriesGroup, () => string> = {
  almond_bloom: () => translate.phrases.banyanApp('Almond Bloom'),
  air_temperature: () => translate.phrases.banyanApp('Temperature'),
  alternaria: () => translate.phrases.banyanApp('Alternaria'),
  bee_hours: () => translate.phrases.banyanApp('Bee Hours'),
  chill: () => translate.phrases.banyanApp('Chill'),
  ...degreeDaysRecord(insectDegreeDaysLabelMaker),
  dew_point: () => translate.phrases.banyanApp('Dew Point'),
  evapotranspiration: () => translate.phrases.banyanApp('Evapotranspiration'),
  fire_blight: () => translate.phrases.banyanApp('Fire Blight'),
  fruit_growth: () => translate.phrases.banyanApp('Fruit Growth'),
  humidity: () => translate.phrases.banyanApp('Humidity'),
  irrigation: () => translate.phrases.banyanApp('Irrigation'),
  leaf_wetness: () => translate.phrases.banyanApp('Leaf Wetness'),
  plant_stress: () => translate.phrases.banyanApp('Plant Stress'),
  precipitation: () => translate.phrases.banyanApp('Rain'),
  soil: () => translate.phrases.banyanApp('Soil'),
  ...trapCatchesRecord(insectTrapCatchesLabelMaker),
  wet_bulb: () => translate.phrases.banyanApp('Wet Bulb'),
  wind: () => translate.phrases.banyanApp('Wind'),
}
